<template>
  <VView class="contest-instructions" back-button-to="/menu" :header="$t('contestInstructions.header')">
   <VText>Pufek unosi się nad ziemią i nie potrafi latać, ale za to doskonale radzi sobie ze skakaniem. umie nawet wykonać podwójny skok!</VText>

    <VBlock max-width="764px">
      <img src="@/assets/instructions-1.png" />
    </VBlock>

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton to="/contest/instructions-2">Dalej</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'ContestInstructions',
};
</script>

<style lang="scss" scoped>
.contest-instructions {}
</style>
